export default __webpack_public_path__ + "static/sc-card-4370699d5ce57496e64e7905a6029b8a.png";